import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef, MatDialogModule} from '@angular/material/dialog';
import {cloneDeep} from 'lodash';
import {VertexLinkService} from '../../services/vertex-link.service';
import {
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import {DomSanitizer} from '@angular/platform-browser';
import {TranslateModule} from '@ngx-translate/core';
import {
  DialogCloseButtonComponent,
  PrimaryButtonComponent,
  SecondaryButtonComponent,
  TextFieldComponent,
  IconButtonComponent
} from '@q9elements/ui-kit/components';
import {Q9Validators} from '@q9elements/ui-kit/validators';
import {MxCell} from '../../shared/models/mx-cell.interface';

@Component({
  selector: 'app-attach-url-dialog',
  templateUrl: './attach-url-dialog.component.html',
  styleUrls: ['./attach-url-dialog.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    TranslateModule,
    DialogCloseButtonComponent,
    TextFieldComponent,
    PrimaryButtonComponent,
    IconButtonComponent,
    SecondaryButtonComponent
  ]
})
export class AttachUrlDialogComponent implements OnInit {
  public cellJson: any;
  public form: UntypedFormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public cell: MxCell,
    private vertexLinkSvc: VertexLinkService,
    private sanitizer: DomSanitizer,
    private dialogRef: MatDialogRef<AttachUrlDialogComponent>
  ) {}

  ngOnInit() {
    this.cellJson = cloneDeep(this.cell.getJson());
    const url = this.cellJson.link || '';

    this.form = new UntypedFormGroup({
      url: new UntypedFormControl(url, [
        Q9Validators.maxLength(1024),
        Q9Validators.minLength(2),
        Q9Validators.required(),
        Q9Validators.pattern(/^[\]A-Za-z0-9_.~!*'();:@&=+$,/?#[%-]+$/)
      ])
    });
  }

  get url() {
    return this.form.get('url').value;
  }

  public openLink() {
    let link = cloneDeep(this.url);

    link = this.validateLink(link);
    window.open(link, '_blank');
  }

  public confirm() {
    if (this.form.valid) {
      let link = cloneDeep(this.url);

      link = this.validateLink(link);
      this.vertexLinkSvc.updateCellJson(this.cell, {link: link});
      this.dialogRef.close();
    }
  }

  private validateLink(link: string) {
    if (!link) {
      return;
    }

    if (!link.match(/^https?:\/\//i)) {
      if (!link.match(/:/)) {
        link = 'http://' + link;
      }
    }

    const trustUrlRegExp = new RegExp(/^\s*(https?|ftp|mailto|iwl):/, `im`);
    const trustUrl = trustUrlRegExp.test(link);

    link = <string>this.sanitizer.bypassSecurityTrustUrl(link);

    if (link['changingThisBreaksApplicationSecurity']) {
      if (trustUrl) {
        return link['changingThisBreaksApplicationSecurity'];
      } else {
        return `unsafe:${link['changingThisBreaksApplicationSecurity']}`;
      }
    }

    return link;
  }
}
